// extracted by mini-css-extract-plugin
module.exports = {"nb-root":"NavBrand_nb-root__pasXl","img":"NavBrand_img__Q8kws"};